import { Base64 } from 'js-base64'

import { CategoryLookup, VendorLookup } from '../services'

type Linkable = { id: string; slug?: string | null }

type LinkableProduct = Linkable & {
  vendor?: { slug?: string | null } | null
}

// An object loaded without its slug (a basket item saved before slugs
// existed, a query that never selected it) links to the ID route, which
// redirects once the page has loaded the slug.
export const vendorPath = ({ id, slug }: Linkable) =>
  slug ? `/vendors/${slug}` : `/vendor/${id}`

export const productPath = ({ id, slug, vendor }: LinkableProduct) =>
  slug && vendor?.slug
    ? `/vendors/${vendor.slug}/products/${slug}`
    : `/product/${id}`

export const categoryPath = (category: Linkable, vendor?: Linkable) => {
  const path = `/category/${category.slug || category.id}`

  return vendor ? `${path}/${vendor.slug || vendor.id}` : path
}

// Null renders as a plain label: NavLink omits the link without a target.
export const menuItemPath = ({
  category,
  url
}: {
  category: Linkable | null
  url: string | null
}) => (category ? categoryPath(category) : url)

const isGlobalId = (value: string, type: string) => {
  try {
    return new RegExp(`^${type}:\\d+$`).test(Base64.decode(value))
  } catch {
    return false
  }
}

export const categoryLookup = (param: string): CategoryLookup =>
  isGlobalId(param, 'Category') ? { id: param } : { slug: param }

export const vendorLookup = (param: string): VendorLookup =>
  isGlobalId(param, 'User') ? { id: param } : { slug: param }

export const samePath = (a: string, b: string) =>
  a.replace(/\/+$/, '') === b.replace(/\/+$/, '')
